.intro {
  margin: 0 0 var(--space-s);

  color: var(--text-muted);
  font-size: var(--size-200);
}

.referrers {
  display: flex;
  flex-direction: column;
  gap: var(--space-xs);

  margin: 0 0 var(--space-m);
  padding: 0;

  list-style: none;
}

.referrers li {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  justify-content: space-between;
  gap: var(--space-xs);

  padding: var(--space-xs) var(--space-s);

  border-inline-start: 3px solid var(--border);
  border-radius: var(--radius-s);

  background-color: rgb(255 255 255 / 5%);
}

/* What goes down with the entity is marked louder than what is only rewritten. */
.cascades {
  border-inline-start-color: var(--band-missing);
}

.detaches {
  border-inline-start-color: var(--border-strong);
}

.referrer {
  font-family: var(--font-mono);
  font-size: var(--size-200);
}

.consequence {
  color: var(--text-muted);
  font-size: var(--size-100);
}

.hint {
  margin: var(--space-xs) 0 var(--space-m);

  color: var(--text-muted);
  font-size: var(--size-100);
}

.failure {
  margin: 0 0 var(--space-m);

  color: var(--band-missing);
  font-size: var(--size-200);
}
